import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import UserHeader from "../components/UserHeader";
import "./AuthenticatedLayout.css";

const MAIN_ROUTES = ["/", "/reportistica", "/automazione", "/produttivita", "/ai-agents", "/applicativi", "/gestione-utenti", "/upload"];

const AuthenticatedLayout = ({ children, onLogout }) => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const location = useLocation();
    const showHamburger = MAIN_ROUTES.includes(location.pathname);

    return (
        <div className="authenticated-layout">
            <Sidebar mobileOpen={sidebarOpen} onMobileClose={() => setSidebarOpen(false)} />
            <div className="main-content">
                {showHamburger && (
                    <button className="mobile-hamburger" onClick={() => setSidebarOpen(true)}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <line x1="3" y1="12" x2="21" y2="12"></line>
                            <line x1="3" y1="6" x2="21" y2="6"></line>
                            <line x1="3" y1="18" x2="21" y2="18"></line>
                        </svg>
                    </button>
                )}

                <div className="fixed-user-header">
                    <UserHeader onLogout={onLogout} />
                </div>
                {children}
            </div>
        </div>
    );
};

export default AuthenticatedLayout;
